import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { RichEditorDualLangTextAreaComponent } from '../../../../../../ui-components/lib/rich-editor-dual-lang-text-area/rich-editor-dual-lang-text-area.component';
import { ValidationMessageComponent } from '../../../../../../ui-components/lib/validation-message/validation-message.component';
import { PaginatedSelectComponent } from '../../../../../../ui-components/lib/paginated-select/paginated-select.component';
import { baseUrl } from '../../../../../common/constants/endpoints.constants';
import { OptionItem } from '../../../../../../ui-components/lib/option.interface';

@Component({
  selector: 'lib-reject-send-forward-modal',
  imports: [
    ReactiveFormsModule,
    TranslocoPipe,
    PaginatedSelectComponent,
    RichEditorDualLangTextAreaComponent,
    ValidationMessageComponent,
  ],
  templateUrl: './reject-send-forward-modal.component.html',
  styleUrl: './reject-send-forward-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class RejectSendForwardModalComponent {
  translocoService = inject(TranslocoService);
  fb = inject(FormBuilder);
  stepId = input.required<string | number>();
  closeModal = output<void>();
  submitSendForward = output<any>();
  sendForwardForm = signal<FormGroup>(
    this.fb.group({
      reason_option_id: ['', Validators.required],
      comment: ['', [Validators.required]],
    })
  );
  baseUrl = baseUrl;

  forwardReasonOptions: OptionItem[] = [
    {
      label: this.translocoService.translate(
        'request_screen_incomplete_information_label'
      ),
      value: 'incomplete_information',
    },
    {
      label: this.translocoService.translate(
        'request_screen_missing_documents_label'
      ),
      value: 'missing_documents',
    },
    {
      label: this.translocoService.translate(
        'request_screen_policy_violation_label'
      ),
      value: 'policy_violation',
    },
    {
      label: this.translocoService.translate(
        'request_screen_other_reason_label'
      ),
      value: 'other_reason',
    },
  ];

  onSubmit(): void {
    if (this.sendForwardForm().valid) {
      const formValue = this.sendForwardForm().getRawValue();
      this.submitSendForward.emit(formValue);
    } else {
      this.sendForwardForm().markAsDirty();
      this.sendForwardForm().markAllAsTouched();
    }
  }

  onClose(): void {
    this.closeModal.emit();
  }
}
